/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { popupControllerCreate } from '../fn/popup/popup-controller-create';
import { PopupControllerCreate$Params } from '../fn/popup/popup-controller-create';
import { popupControllerDelete } from '../fn/popup/popup-controller-delete';
import { PopupControllerDelete$Params } from '../fn/popup/popup-controller-delete';
import { popupControllerFindAll } from '../fn/popup/popup-controller-find-all';
import { PopupControllerFindAll$Params } from '../fn/popup/popup-controller-find-all';
import { popupControllerFindById } from '../fn/popup/popup-controller-find-by-id';
import { PopupControllerFindById$Params } from '../fn/popup/popup-controller-find-by-id';
import { popupControllerReorder } from '../fn/popup/popup-controller-reorder';
import { PopupControllerReorder$Params } from '../fn/popup/popup-controller-reorder';
import { popupControllerSearchOffset } from '../fn/popup/popup-controller-search-offset';
import { PopupControllerSearchOffset$Params } from '../fn/popup/popup-controller-search-offset';
import { popupControllerUpdate } from '../fn/popup/popup-controller-update';
import { PopupControllerUpdate$Params } from '../fn/popup/popup-controller-update';
import { PopupDto } from '../models/popup-dto';

@Injectable({ providedIn: 'root' })
export class PopupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `popupControllerFindAll()` */
  static readonly PopupControllerFindAllPath = '/api/popup';

  /**
   * 노출된 팝업 목록 조회.
   *
   * 노출된 팝업을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindAll$Response(params?: PopupControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    const obs = popupControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 노출된 팝업 목록 조회.
   *
   * 노출된 팝업을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindAll(params?: PopupControllerFindAll$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    const resp = this.popupControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

  /** Path part for operation `popupControllerCreate()` */
  static readonly PopupControllerCreatePath = '/api/popup';

  /**
   * 팝업 생성.
   *
   * 팝업을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreate$Response(params: PopupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 생성.
   *
   * 팝업을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreate(params: PopupControllerCreate$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerSearchOffset()` */
  static readonly PopupControllerSearchOffsetPath = '/api/popup/search/offset';

  /**
   * 팝업 오프셋 기반 조회.
   *
   * 팝업을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearchOffset$Response(params: PopupControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = popupControllerSearchOffset(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 오프셋 기반 조회.
   *
   * 팝업을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearchOffset(params: PopupControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.popupControllerSearchOffset$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `popupControllerFindById()` */
  static readonly PopupControllerFindByIdPath = '/api/popup/{id}';

  /**
   * 팝업 ID 기반 조회.
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindById$Response(params: PopupControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 ID 기반 조회.
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindById(params: PopupControllerFindById$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerDelete()` */
  static readonly PopupControllerDeletePath = '/api/popup/{id}';

  /**
   * 팝업 삭제.
   *
   * 팝업을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDelete$Response(params: PopupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 삭제.
   *
   * 팝업을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDelete(params: PopupControllerDelete$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerUpdate()` */
  static readonly PopupControllerUpdatePath = '/api/popup/{id}';

  /**
   * 팝업 수정.
   *
   * 팝업을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdate$Response(params: PopupControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 수정.
   *
   * 팝업을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdate(params: PopupControllerUpdate$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerReorder()` */
  static readonly PopupControllerReorderPath = '/api/popup/reorder';

  /**
   * 팝업 순서 변경.
   *
   * 팝업의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorder$Response(params: PopupControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    const obs = popupControllerReorder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 순서 변경.
   *
   * 팝업의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorder(params: PopupControllerReorder$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    const resp = this.popupControllerReorder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

}
